<div class="flex flex-col gap-2">
  <app-label>색상</app-label>
  <div class="relative">
    <button
      (click)="open.set(true)"
      (clickOutside)="open.set(false)"
      class="flex gap-2 items-center"
    >
      <div
        class="size-6 rounded-full color-section"
        [attr.data-color]="value()"
      ></div>
      <p [attr.data-theme]="theme()" class="theme-text">{{ value() }}</p>
    </button>
    @if (open()) {
      <div class="absolute z-50 top-[100%]">
        <ng-container *ngTemplateOutlet="menu" />
      </div>
    }
  </div>
</div>

<ng-template #menu>
  <app-menu overflow>
    @for (color of colors; track $index) {
      <app-menu-option (click)="writeValue(color)">
        <div class="flex gap-2 items-center">
          <div
            class="color-section size-6 rounded-full"
            [attr.data-color]="color"
          ></div>
          <p>{{ color }}</p>
        </div>
      </app-menu-option>
    }
  </app-menu>
</ng-template>
